import { render, staticRenderFns } from "./RoamingDialog.vue?vue&type=template&id=07f64efd&scoped=true"
import script from "./RoamingDialog.vue?vue&type=script&lang=js"
export * from "./RoamingDialog.vue?vue&type=script&lang=js"
import style0 from "./RoamingDialog.vue?vue&type=style&index=0&id=07f64efd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f64efd",
  null
  
)

export default component.exports